/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#carnet-search[_ngcontent-%COMP%]{margin:10px;padding-bottom:10px}button[_ngcontent-%COMP%]{margin-bottom:10px}"];
export { styles as styles };
